/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import {
  apiUrlB2B,
  deliveryId,
  uniqueID,
  PAYMENT_UI_CONFIG,
  VOUCHER_GLOBAL_PURPOSE,
} from "../../../utils/constants";
import {
  addCountryCode,
  axiosInstance,
  calculateAddonPackagingFee,
  checkScope,
  dateToUnix,
  encodeValue,
  formatRupiah,
  getSecondsLeft,
  isEmptyData,
  sendAnalyticsCustomEvent,
  sendAnalyticsPageView,
  sortVouchers,
  trackMetaPixelEvent,
  unixToDate,
  cleanText,
  authHeaders
} from "../../../utils/helper";
import qs from "qs";
import { useFormik } from "formik";
import * as Yup from "yup";
import { BottomSheet } from "react-spring-bottom-sheet";
import ProductSimple from "../../../components/Product/simple";
import { ComboDetail } from "../../../components/Product/combo";
import { useDispatch, useSelector } from "react-redux";
import { clearPayment, setPayment } from "../../../store/reducers/payment";
import { TooFar } from "../../../components/Errors";
import Loader from "../../../components/Loader";
import { listPaymentMethod, UFOODX_BASE_URL } from "../../../utils/constants";
import useNavigation from "../../../hook/useNavigation";
import OrderOption from "../../components/OrderOption";
import OutletDetail from "../../../ufood-x/components/Summary/OutletDetail";
import moment from "moment-timezone";
import DeliveryOption from "../../components/Summary/DeliveryOption";
import TableNumber from "../../components/Outlet/TableNumber";
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import { removeCart } from '../../../store/reducers/cart';
import { getVouchersLoyalty } from "../../../store/reducers/loyalty";
// Components

import DeliveryPartnerOption from "../../components/Orders/Summary/DeliveryPartnerOption";
import PaymentOption from "../../components/Orders/Summary/PaymentOption";
import ProductOption from "../../components/Orders/Summary/ProductOption";
import PaymentSummaryOption from "../../components/Orders/Summary/PaymentSummaryOption";
import NotesOption from "../../components/Orders/Summary/NotesOption";
import VoucherOption from "../../components/Orders/Summary/VoucherOption";
import PaymentMethod from "../../components/Orders/Summary/PaymentMethod";
import DeliveryBottomSheet from "../../components/Orders/Summary/DeliveryBottomSheet";
import VoucherBottomSheet from "../../components/Orders/Summary/VoucherBottomSheet";
import SummaryFooter from "../../components/Orders/Summary/SummaryFooter";
import WarningVoucherFooter from "../../components/Orders/Summary/WarningVoucherFooter";
import { showError, subscribeError } from "../../hook/useError";
import OutletClosedCard from '../../../components/Outlet/OutletClose';
import useColor from '../../../hook/useColor';

const Summary = () => {
  useColor();
  const dispatch = useDispatch();
  const navigate = useNavigation();

  const user = useSelector((store) => store?.user);
  const device = useSelector((store) => store?.device);
  const { details: outlet } = useSelector((store) => store?.outlet);
  const order = useSelector((store) => store?.order);
  const { isLoadingVoucher: isLoadingVoucherLoyalty, vouchers: voucherList, loyalty } = useSelector((store) => store?.loyalty);

  const [product, setProduct] = useState(null);
  const [item, setItem] = useState(null);
  const [cartItem, setCartItem] = useState(null);
  const [cart, setCart] = useState(null);
  const [totalOrder, setTotalOrder] = useState(null);

  const [pathnerList, setPathnerList] = useState([]);
  const [selectedPathner, setSelectedPathner] = useState(null);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [b2bVoucherList, setB2bVoucherList] = useState([]);
  const [voucherGlobalList, setVoucherGlobalList] = useState([]);
  const [loyaltyVoucherList, setLoyaltyVoucherList] = useState([]);

  const [isLoadingPaymentMethodList, setisLoadingPaymentMethodList] =
    useState(false);
  const [isLoadingDeliveryList, setisLoadingDeliveryList] = useState(false);
  const [isShowDelivery, setIsShowDelivery] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowBottomSheet, setIsShowBottomSheet] = useState(false);
  const [isShowSimpleProduct, setIsShowSimpleProduct] = useState(false);
  const [isShowComboProduct, setIsShowComboProduct] = useState(false);
  const [isLoadingVoucherList, setisLoadingVoucherList] = useState(false);
  const [isShowVoucher, setIsShowVoucher] = useState(false);
  const [isShowPaymentMethod, setIsShowPaymentMethod] = useState(false);
  const [isShowDeliveryLocation, setIsShowDeliveryLocation] = useState(false);
  const [isTooFar, setIsTooFar] = useState(false);
  const [showClosed, setShowClosed] = useState(false);

  const [showVoucherDetail, setShowVoucherDetail] = useState({
    isOpen: false,
    data: null,
    type: null
  });

  const [errorOpen, setErrorOpen] = useState(false);

  const nameOrderType = cleanText(order?.selectedOrderType?.av_name);
  const [defaultValues, setDefaultValues] = useState({
    unquieid: uniqueID,
    paymentReference: null,
    orderType: order?.selectedOrderType?.av_name?.toLowerCase(),
    availabilityID: order?.selectedOrderType?.av_id,
    availabilityName: order?.selectedOrderType?.av_name,
    orderSource: "web",
    instantOrder: "Yes",
    orderLocalNumber: null,
    additionalDeliveryCharge: 0,
    taxCharge: 0,
    taxAmount: 0,
    totalDiscount: 0,
    discountType: "",
    sender: {
      firstName: user?.firstName,
      email: user?.email ?? "",
      phone: user?.primary_phone
    },
    deliveryType: null,
    deliveryFee: 0,
    deliverySubsidies: 0,
    notes: "",
    paymentType: null,
    origin: null,
    destinations: {
      address: user?.address,
      coordinate: {
        latitude: user?.latitude,
        longitude: user?.longitude
      },
      village: user?.village,
      district: user?.district,
      city: user?.city,
      province: user?.state,
      postalCode: user?.postalCode ?? "",
      state: user?.state,
      country: user?.country,
      recipient: {
        firstName: user?.firstName,
        email: user?.email || "",
        phone: user?.primary_phone,
        lastName: user?.lastName || "",
        detail: user?.detail || "-"
      },
      items: []
    },
    pin: null
  });

  const [isShowWarningVoucher, setIsShowWarningVoucher] = useState(false);
  const [dataVoucherWarning, setDataVoucherWarning] = useState(null);
  const [isShowWarningRedeem, setIsShowWarningRedeem] = useState(false);
  const [dataVoucherRedeem, setDataVoucherRedeem] = useState(null);

  const orderSchema = Yup.object().shape({
    unquieid: Yup.string().required("Unique ID diperlukan"),
    orderType: Yup.string().required("Order Type diperlukan"),
    availabilityID: Yup.string().required("availabilityID diperlukan"),
    availabilityName: Yup.string().required("availabilityName diperlukan"),
    orderLocalNumber: Yup.string().required("orderLocalNumber diperlukan"),
    paymentReference: Yup.string().required("paymentReference diperlukan"),
    notes: Yup.string().optional(),

    sender: Yup.object().shape({
      firstName: Yup.string().required("Nama Depan diperlukan"),
      phone: Yup.string().required("Nomor Telepon diperlukan")
    }),

    deliveryType: Yup.mixed().when("orderType", {
      is: (orderType) => orderType === "delivery",
      then: (schema) =>
        schema
          .test(
            "is-delivery-valid",
            "Tipe Pengiriman tidak ditemukan",
            (delivery) => {
              if (typeof delivery === "object") return true;
              return false;
            }
          )
          .required("Pilih Pengiriman"),
      otherwise: (schema) => schema.notRequired()
    }),

    paymentType: Yup.mixed()
      .test(
        "is-payment-type-valid",
        "Tipe Pembayaran diperlukan",
        (payment) => {
          if (typeof payment === "object") {
            return true;
          }
          return false;
        }
      )
      .required("Pilih Pembayaran"),

    origin: Yup.object().shape({
      storeID: Yup.string().required("Store ID diperlukan"),
      address: Yup.string().required("Alamat asal wajib ada."),
      keywords: Yup.string().required("Keywords wajib ada."),
      coordinate: Yup.object().shape({
        latitude: Yup.string().required("Latitude asal wajib ada."),
        longitude: Yup.string().required("Longitude asal wajib ada.")
      }),
      village: Yup.string().required("Desa/Keluharan asal wajib ada."),
      district: Yup.string().required("Kecamatan asal wajib ada."),
      city: Yup.string().required("Kota/Kabupaten asal wajib ada."),
      province: Yup.string().required("Provinsi asal wajib ada."),
      postalCode: Yup.string().required("Kode Pos asal wajib ada.")
    }),

    destinations: Yup.object().when("orderType", {
      is: (orderType) => orderType === "delivery",
      then: (schema) =>
        schema.shape({
          address: Yup.string().required("Alamat tujuan wajib ada."),
          coordinate: Yup.object().shape({
            latitude: Yup.string().required("Latitude tujuan wajib ada."),
            longitude: Yup.string().required("Longitude tujuan wajib ada.")
          }),
          village: Yup.string().required("Desa/Kelurahan tujuan wajib ada."),
          district: Yup.string().required("Kecamatan tujuan wajib ada."),
          city: Yup.string().required("Kota/Kabupaten tujuan wajib ada."),
          province: Yup.string().required("Provinsi tujuan wajib ada."),
          postalCode: Yup.string(),
          recipient: Yup.object().shape({
            firstName: Yup.string().required("Nama penerima wajib ada."),
            phone: Yup.string().required("Nomor telepon penerima wajib ada.")
          }),
          items: Yup.array()
            .min(1, "Minimal satu item wajib ditambahkan.")
            .required("Item wajib ditambahkan.")
        }),
      otherwise: (schema) => schema.notRequired()
    })
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: defaultValues,
    validationSchema: orderSchema,
    onSubmit: async () => {
      await handlePayment();
    }
  });

  const { errors, touched, handleSubmit, values, setValues, isSubmitting } =
    formik;

  const findFirstError = (errors) => {
    if (errors.destinations && errors.destinations.address) {
      return errors.destinations.address;
    }

    for (const key in errors) {
      if (typeof errors[key] === "object" && errors[key] !== null) {
        const nestedError = findFirstError(errors[key]);
        if (nestedError) {
          return nestedError;
        }
      }
      if (typeof errors[key] === "string") {
        return errors[key];
      }
    }
    return null;
  };

  useEffect(() => {
    if (typeof window.gtag !== 'function') return;
    sendAnalyticsPageView('summary_session');
  }, [window.gtag]);

  useEffect(() => {
    if (typeof window.gtag !== 'function') return;
    if (isShowPaymentMethod) {
      sendAnalyticsPageView("payment_methods_session");
    }
  }, [isShowPaymentMethod, window.gtag]);

  useEffect(() => {
    if (typeof window.gtag !== 'function') return;
    if (isShowVoucher) {
      sendAnalyticsPageView("voucher_session");
    }
  }, [isShowVoucher, window.gtag]);

  useEffect(() => {
    if (Object.keys(errors).length > 0 && Object.keys(touched).length > 0) {
      const firstError = findFirstError(errors);
      if (firstError) {
        showError({
          title: firstError,
        });
      }
    }
  }, [isSubmitting]);

  const handleCart = async (data) => {
    console.log("handleCart");
    try {
      setIsLoading(true);
      let postData = {
        unquieid: uniqueID,
        availabilityID: order?.selectedOrderType?.av_id || deliveryId,
        availabilityName: order?.selectedOrderType?.av_name || "Delivery",
        shopID: encodeValue(outlet?.storeID),
      };
      if (data?.productType === "Simple") {
        postData = {
          ...postData,
          ...data
        };
      } else {
        postData = {
          ...postData,
          ...data,
          comboset: JSON.stringify(data?.comboset)
        };
      }

      const url = `cart/${data?.type === "add" ? "createCart" : "updateCartItem"}`;
      const res = await axiosInstance.post(url, qs.stringify(postData), authHeaders());
      if (res?.data?.status === "ok") {
        setCartItem(null);
        setProduct(null);
        setItem(null);
        handleCloseBottomSheet();
        await handleGetCart();
      }
      setIsLoading(false);
    } catch (error) {
      console.log("error: ", error);
      setIsLoading(false);
    }
  };

  const handleGetTotalOrder = async () => {
    try {
      setIsLoading(true);
      const formData = new URLSearchParams();
      formData.append("unquieid", uniqueID);

      const url = `orders/total-order`;
      const res = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          ...authHeaders().headers
        }
      });

      if (res?.status === 200) {
        setTotalOrder(Number(res?.data?.result) || 0);
      }
    } catch (error) {
      console.log("error: ", error);
      setIsLoading(false);
    }
  };

  const handleGetCart = async () => {
    if (!user?.token) return;
    console.log("handleGetCart");
    try {
      setIsLoading(true);
      const url = `cart/loadCartDetails?unquieid=${uniqueID}&availabilityID=${order?.selectedOrderType?.av_id}`;
      const res = await axiosInstance.get(url, {
        headers: {
          Accept: "application/json, text/plain, */*",
          ...authHeaders().headers
        }
      });
      if (res?.data?.status === "ok") {
        setCart(res?.data?.result || null);
      }
      if (res?.data?.message === "There are no items in your cart") {
        isEmptyData(outlet?.storeSlug)
          ? navigate.back()
          : navigate.push(`/${UFOODX_BASE_URL}`);
      }
      setIsLoading(false);
    } catch (error) {
      console.log("error: ", error);
      setIsLoading(false);
    }
  };

  const axiosRetry = async (
    url,
    data,
    config,
    maxRetries = 3,
    delayMs = 500
  ) => {
    let attempts = 0;
    console.log("axiosRetry: ", attempts);
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    while (attempts < maxRetries) {
      try {
        const res = await axiosInstance.post(url, JSON.stringify(data), config);
        console.log(`Attempt ${attempts + 1}: Status ${res?.status}`);

        if (res?.data?.status === "ok") {
          return res;
        } else {
          console.log(`Attempt ${attempts + 1}`);
        }
      } catch (error) {
        console.log(`Attempt ${attempts + 1}: Error`, error);
      }

      attempts += 1;
      if (attempts < maxRetries) {
        console.log(`Retrying in ${delayMs}ms... (${attempts}/${maxRetries})`);
        await delay(delayMs);
      }
    }

    return null;
  };

  const handleSetSelectedUfoodPathner = (serviceList = []) => {
    if (!serviceList?.length) return null;
    console.log("handleSetSelectedUfoodPathner");
    const ufood = serviceList?.find((service) => service?.name === "UFood");
    if (Boolean(ufood ?? null)) {
      setSelectedPathner(ufood ?? null);
      if (!ufood?.vehicle?.length) return;
      return ufood?.vehicle?.[0] ?? null;
    }
    return null;
  };

  const handleGetPathnerList = async () => {
    if (
      !user?.token ||
      !cart?.store?.storeAddress ||
      !user?.address ||
      isLoadingDeliveryList
    )
      return;
    console.log("handleGetPathnerList");
    try {
      setisLoadingDeliveryList(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          ...authHeaders().headers
        }
      };

      const dataPost = {
        unquieid: uniqueID,
        sender: {
          firstName: user?.firstName,
          email: user?.email ?? "",
          phone: user?.primary_phone
        },
        origin: {
          address: cart?.store?.storeAddress,
          coordinate: cart?.store?.coordinate,
          village: cart?.store?.village,
          district: cart?.store?.district,
          city: cart?.store?.city,
          province: cart?.store?.province,
          postalCode: cart?.store?.postalCode ?? "",
          keywords: cart?.store?.storeName
        },
        destinations: {
          address: user?.address,
          coordinate: {
            latitude: user?.latitude,
            longitude: user?.longitude
          },
          village: user?.village,
          district: user?.district,
          city: user?.city,
          province: user?.state,
          postalCode: user?.postalCode ?? "",
          state: user?.state,
          country: user?.country,
          recipient: {
            firstName: user?.firstName,
            email: user?.email ?? "",
            phone: user?.primary_phone,
            lastName: user?.lastName
          },
          items: (cart?.item || [])?.map((product, index) => {
            return {
              itemName: product?.itemName,
              itemQuantity: product?.itemQuantity,
              itemRemarks: product?.itemNotes ?? ""
            };
          })
        },
        store_id: cart?.store?.storeID
      };

      const url = `deliverypartners/loadPartnersList`;
      const res = await axiosRetry(url, dataPost, config, 3, 1500);

      if (res?.data?.status === "ok" && res?.data?.result?.length) {
        const { delivery_fee, delivery_subsidies } = res?.data || {};
        const result = res?.data?.result || [];
        const normalizedVehicleData = result?.map((item) => {
          item.vehicle = item.vehicle.map((vehicle) => {
            return vehicle;
          });
          return item;
        });
        const serviceList = normalizedVehicleData
          ?.map((item) => item.vehicle)
          .flat()
          .reduce((acc, vehicle) => {
            const existingService = acc.find(
              (service) =>
                service.name === vehicle.name &&
                service.serviceType === vehicle.serviceType
            );

            if (existingService) {
              existingService.vehicle.push(vehicle);
            } else {
              acc.push({
                name: vehicle.name,
                serviceType: vehicle.serviceType,
                vehicle: [vehicle]
              });
            }

            return acc;
          }, [])
          .sort((a, b) => {
            if (a.name === "UFood") return -1;
            if (b.name === "UFood") return 1;
            return 0;
          });
        setPathnerList(serviceList);
        const bike = handleSetSelectedUfoodPathner(serviceList);
        setDefaultValues((prev) => {
          return {
            ...prev,
            deliveryFee: Number(delivery_fee) || 0,
            deliverySubsidies: Number(delivery_subsidies) || 0,
            deliveryType: bike
          };
        });
        handleCloseBottomSheet();
      } else {
        handleCloseBottomSheet();
        setPathnerList([]);
        setSelectedPathner(null);
        setIsShowBottomSheet(true);
        setIsTooFar(true);
      }
      setisLoadingDeliveryList(false);
    } catch (error) {
      console.log("error: ", error);
      setisLoadingDeliveryList(false);
    }
  };

  const handleGetPaymentReference = async (needReturn = false) => {
    if (!user?.token) return;
    try {
      console.log("handleGetPaymentReference");
      setIsLoading(true);
      const postData = {
        unquieid: uniqueID,
      };

      const url = `Paymentuvcr/generatePaymentRefrence`;

      const res = await axiosInstance.post(url, qs.stringify(postData), authHeaders());
      if (res?.data?.status === "ok") {
        const reference = res?.data?.paymentRefrence || "";
        const orderNumber = res?.data?.order_local_no || "";
        if (!needReturn) {
          setDefaultValues((prev) => {
            return {
              ...prev,
              paymentReference: reference,
              orderLocalNumber: orderNumber
            };
          });
        } else {
          return {
            paymentReference: reference,
            orderLocalNumber: orderNumber
          };
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.log("error: ", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    dispatch(clearPayment());
  }, []);

  useEffect(() => {
    handleGetTotalOrder();
    handleGetCart();
  }, [user?.token, order?.selectedOrderType?.av_id]);

  useEffect(() => {
    if (isEmptyData(defaultValues?.paymentReference)) {
      handleGetPaymentReference();
    }
  }, [user?.token, defaultValues?.paymentReference]);

  useEffect(() => {
    if (!cart?.store?.storeAddress) return;
    setDefaultValues((prev) => {
      return {
        ...prev,
        origin: {
          outletBrandID: cart?.store?.outletBrandID,
          storeID: cart?.store?.storeID,
          name: cart?.store?.storeName || "",
          address: cart?.store?.storeAddress || "",
          open: cart?.store?.storeOpen || "",
          openTime: cart?.store?.outletOpenTime || "",
          closeTime: cart?.store?.outletCloseTime || "",
          unit: cart?.store?.unit || "",
          floor: cart?.store?.floor || "",
          coordinate: cart?.store?.coordinate || {},
          village: cart?.store?.village || "",
          district: cart?.store?.district || "",
          city: cart?.store?.city || "",
          province: cart?.store?.province || "",
          postalCode: cart?.store?.postalCode || "",
          keywords: cart?.store?.storeName || ""
        },
        sender: {
          firstName: user?.firstName,
          email: user?.email || "",
          phone: user?.primary_phone
        },
        destinations: {
          address: user?.address,
          coordinate: {
            latitude: user?.latitude,
            longitude: user?.longitude
          },
          village: user?.village,
          district: user?.district,
          city: user?.city,
          province: user?.state,
          postalCode: user?.postalCode || "",
          state: user?.state,
          country: user?.country,
          recipient: {
            firstName: user?.firstName,
            email: user?.email || "",
            phone: user?.primary_phone,
            lastName: user?.lastName || "",
            detail: user?.detail || "-"
          },
          items: cart?.item || []
        }
      };
    });
  }, [cart?.store?.storeAddress, user?.address]);

  useEffect(() => {
    handleGetB2BVoucherList();
  }, [cart?.store?.posID]);

  useEffect(() => {
    handleGetVoucherGlobalList();
  }, [cart?.subTotal, totalOrder]);

  useEffect(() => {
    if (order?.selectedOrderType?.av_name?.toLowerCase() === "delivery") {
      handleGetPathnerList();
    }
  }, [
    user?.token,
    cart?.store?.storeAddress,
    user?.address,
    order?.selectedOrderType?.av_name?.toLowerCase()
  ]);

  const handleGetProductDetail = async (slug, data) => {
    console.log("handleGetProductDetail");
    try {
      setIsLoading(true);
      const url = `catalogs/productdetails?unquieid=${uniqueID}&productID=${slug}`;
      const res = await axiosInstance.get(url, {
        headers: {
          Accept: "application/json, text/plain, */*",
          ...authHeaders().headers
        }
      });
      if (res.data?.status === "ok") {
        const product = res.data?.result || null;
        setCartItem(product);
        setProduct(product);
        setItem(data);
        setIsShowBottomSheet(true);
        if (product?.product_type === "1") {
          setIsShowSimpleProduct(true);
        }
        if (product?.product_type === "2") {
          setIsShowComboProduct(true);
        }
      }
      if (res?.data?.status === "error") {
        showError({
          title: "Product not found",
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log("error: ", error);
      setIsLoading(false);
    }
  };

  const groupByNominal = async (b2bVoucherList = []) => {
    console.log("groupByNominal");
    const result = [];

    b2bVoucherList?.forEach((voucher) => {
      const existingVoucher = result.find((v) => v.nominal === voucher.nominal);

      if (existingVoucher) {
        existingVoucher.total_is_use += voucher.is_use ? 1 : 0;
        existingVoucher.total_stock_available += voucher.stock_available;
      } else {
        result.push({
          ...voucher,
          total_is_use: voucher.is_use ? 1 : 0,
          total_stock_available: voucher.stock_available
        });
      }
    });

    return result;
  };

  const validationVoucherGlobalForProduct = async (voucher = {}) => {
    let nominal_voucher = 0;
    let applied_products = [];

    if (Number(cart?.subTotal) < voucher?.min_transaction) {
      return {
        is_use: nominal_voucher > 0,
        nominal_voucher: nominal_voucher,
        applied_products: [],
        disabled: true
      };
    }

    const matchCompany = checkScope(
      voucher?.company_scope_ids,
      user?.companyID
    );
    const matchBrand = checkScope(
      voucher?.brand_scope_ids,
      cart?.store?.outletBrandID
    );
    const matchOutlet = checkScope(
      voucher?.outlet_scope_ids,
      cart?.store?.storeID
    );
    const matchUser = checkScope(voucher?.user_scope_ids, user?.customerID);

    if (!matchCompany || !matchBrand || !matchOutlet || !matchUser) {
      return {
        is_use: nominal_voucher > 0,
        nominal_voucher: nominal_voucher,
        applied_products: [],
        disabled: true
      };
    }

    if (matchCompany || matchBrand || matchOutlet || matchUser) {
      const price = Number(cart?.subTotal) || 0;
      if (voucher.type === "nominal") {
        nominal_voucher = voucher.value;
      }
  
      if (voucher.type === "percentage") {
        nominal_voucher = (price * voucher.value) / 100;
      }
    }

    if (
      !isEmptyData(voucher?.categories_scope_ids) ||
      !isEmptyData(voucher?.product_scope_ids)
    ) {
      nominal_voucher = 0;
      applied_products = [];

      for (const i of cart?.item || []) {
        const matchCategory = checkScope(
          voucher?.categories_scope_ids,
          i?.product_category_id
        );
        const matchProduct = checkScope(
          voucher?.product_scope_ids,
          i?.product_primary_id
        );

        if (!matchCategory || !matchProduct) {
          continue;
        }

        let discount = 0;

        if (matchCategory && isEmptyData(voucher?.product_scope_ids)) {
          let productPrice = Number(i?.itemUnitPrice);
          if (!isEmptyData(i?.comboset)) {
            i?.comboset?.forEach((c) => {
              c?.productDetails?.forEach((p) => {
                productPrice += Number(p?.productPrice || 0);
              });
            });
          }

          if (voucher?.type === "nominal") {
            discount = voucher.value;
          }
  
          if (voucher?.type === "percentage") {
            discount = (Number(productPrice) * voucher.value) / 100;
            if (discount > voucher?.max_discount) {
              discount = voucher?.max_discount;
            }
          }

          applied_products.push({
            itemID: i.itemID,
            itemName: i.itemName,
            company_id: user?.companyID,
            brand_id: cart?.store?.outletBrandID,
            category_id: i.product_category_id,
            product_id: i.product_primary_id,
            user_id: user?.customerID,
            quantity: Number(i.itemQuantity),
            unitPrice: Number(i.itemUnitPrice),
            totalPrice: Number(i.itemTotalPrice),
            discount: discount
          });
        }

        if (matchProduct && !isEmptyData(voucher?.product_scope_ids)) {
          discount = 0;
          applied_products = [];

          let productPrice = Number(i?.itemUnitPrice);
          if (!isEmptyData(i?.comboset)) {
            i?.comboset?.forEach((c) => {
              c?.productDetails?.forEach((p) => {
                productPrice += Number(p?.productPrice || 0);
              });
            });
          }

          productPrice = productPrice * i?.itemQuantity;

          if (voucher?.type === "nominal") {
            discount = voucher.value;
          }

          if (voucher?.type === "percentage") {
            discount = (Number(productPrice) * voucher.value) / 100;
            if (discount > voucher?.max_discount) {
              discount = voucher?.max_discount;
            }
          }

          applied_products.push({
            itemID: i.itemID,
            itemName: i?.itemName,
            company_id: user?.companyID,
            brand_id: cart?.store?.outletBrandID,
            category_id: i?.product_category_id,
            product_id: i?.product_primary_id,
            user_id: user?.customerID,
            quantity: Number(i?.itemQuantity),
            unitPrice: Number(i?.itemUnitPrice),
            totalPrice: Number(i?.itemTotalPrice),
            discount: discount
          });
        }

        nominal_voucher += discount;
      }
    } else {
      nominal_voucher = 0;
      applied_products = [];
      for (const i of cart?.item || []) {
        let discount = 0;
        const itemQuantity = Number(i?.itemQuantity) || 0;
        const itemUnitPrice = Number(i?.itemUnitPrice) || 0;
        const itemTotalPrice = Number(i?.itemTotalPrice) || 0;

        let productPrice = Number(i?.itemTotalPrice);

        if (voucher?.type === "nominal") {
          discount = productPrice;
        }

        applied_products.push({
          itemID: i?.itemID,
          itemName: i?.itemName,
          company_id: user?.companyID,
          brand_id: cart?.store?.outletBrandID,
          category_id: i?.product_category_id,
          product_id: i?.product_primary_id,
          user_id: user?.customerID,
          quantity: itemQuantity,
          unitPrice: itemUnitPrice,
          totalPrice: itemTotalPrice,
          discount,
        });
        nominal_voucher += discount;
      }

      if (voucher?.type === "percentage") {
        const discountPercentage = (Number(cart?.subTotal) * voucher.value) / 100;
        if (discountPercentage > voucher?.max_discount) {
          nominal_voucher = voucher?.max_discount;
        } else {
          nominal_voucher = discountPercentage;
        }
      }
    }

    nominal_voucher = Math.round(Math.min(nominal_voucher, voucher?.type === "nominal" ? voucher?.value : voucher.max_discount ?? nominal_voucher));

    return {
      is_use: nominal_voucher > 0,
      nominal_voucher: nominal_voucher,
      applied_products,
      disabled: nominal_voucher <= 0
    };
  };

  const validationVoucherGlobalForDelivery = async (voucher = {}) => {
    console.log('validationVoucherGlobalForDelivery');
    let nominal_voucher = 0;
    const price = Number(values?.deliveryType?.amount);
    const voucherValue = Number(voucher?.value ?? 0);
    const maxDiscount = Number(voucher?.max_discount ?? 0);
    if (price === 0) return;
    
    if ((Number(cart?.subTotal) < voucher?.min_transaction) || values?.orderType?.toUpperCase() !== VOUCHER_GLOBAL_PURPOSE.DELIVERY) {
      return {
        is_use: nominal_voucher > 0,
        nominal_voucher: nominal_voucher,
        disabled: true,
      }
    };

    const matchCompany  = checkScope(voucher?.company_scope_ids, user?.companyID);
    const matchBrand    = checkScope(voucher?.brand_scope_ids, cart?.store?.outletBrandID);
    const matchOutlet   = checkScope(voucher?.outlet_scope_ids, cart?.store?.storeID);
    const matchUser  = checkScope(voucher?.user_scope_ids, user?.customerID);    
    if (!matchCompany || !matchBrand || !matchOutlet || !matchUser) {
      return {
        is_use: nominal_voucher > 0,
        nominal_voucher: nominal_voucher,
        disabled: true,
      }
    }

    if (matchCompany || matchBrand || matchOutlet || matchUser) {  
      if (voucher.type === "nominal") {
        nominal_voucher = voucher.value;
      }
  
      if (voucher.type === "percentage") {
        nominal_voucher = (price * voucher.value) / 100;
      }

      nominal_voucher = Math.round(
        Math.min(
          nominal_voucher,
          voucher?.type === "nominal"
            ? voucher?.value
            : (voucher.max_discount ?? nominal_voucher)
        )
      );
    }

    if (matchCompany || matchBrand || matchOutlet || matchUser) {  
      if (voucher.type === "nominal") {
        nominal_voucher = voucher.value;
      }
  
      if (voucher.type === "percentage") {
        nominal_voucher = (price * voucher.value) / 100;
      }

      nominal_voucher = Math.round(
        Math.min(
          nominal_voucher,
          voucher?.type === "nominal"
            ? voucher?.value
            : (voucher.max_discount ?? nominal_voucher)
        )
      );
    }

    if (!isEmptyData(voucher?.categories_scope_ids) || !isEmptyData(voucher?.product_scope_ids)) {
      let hasMatch = false;

      for (const item of cart?.item || []) {
        const matchCategory = checkScope(voucher.categories_scope_ids, item.product_category_id);
        const matchProduct = checkScope(voucher.product_scope_ids, item.product_primary_id);

        if (matchCategory || matchProduct) {
          hasMatch = true;
          break;
        }
      }

      if (!hasMatch) {
        return {
          is_use: nominal_voucher > 0,
          nominal_voucher,
          disabled: true,
        };
      }
    }

    if (!isEmptyData(voucher?.delivery_scope_ids)) {
      const selectedDeliery = isEmptyData(values?.deliveryType) ? null : `${values?.deliveryType?.deliveryPartnerId}|${values?.deliveryType?.name}|${values?.deliveryType?.serviceType}|${values?.deliveryType?.vehicleType}`;
      const matchDelivery = checkScope(voucher?.delivery_scope_ids, selectedDeliery)

      if (!matchDelivery && !isEmptyData(selectedDeliery)) {
        return {
          is_use: nominal_voucher > 0,
          nominal_voucher: nominal_voucher,
          disabled: true,
        }
      }

      const discountValue =
				voucher?.type === 'nominal'
					? voucherValue
					: voucher?.type === 'percentage'
						? (price * voucherValue) / 100
						: 0;

			if (discountValue > 0) {
				nominal_voucher = Math.min(
					discountValue,
					price,
					...(maxDiscount > 0 ? [maxDiscount] : []),
				);
			}

      nominal_voucher = Math.round(nominal_voucher);

      return {
        is_use: nominal_voucher > 0,
        nominal_voucher: nominal_voucher,
        disabled: false,
      }
    }
    
    return {
      is_use: nominal_voucher > 0,
      nominal_voucher: nominal_voucher,
      disabled: false,
    }
  }

  const applyBestVoucher = (vouchers = [], type = VOUCHER_GLOBAL_PURPOSE.PRODUCT) => {
    if (!vouchers.length) return [];

    const filteredVouchers = vouchers.filter(
      v => v?.purpose?.toUpperCase() === type?.toUpperCase()
    );

    // cari nominal_voucher terbesar
    const maxVoucher = Math.max(
      ...filteredVouchers.map(v => v.nominal_voucher || 0)
    );

    // cari index voucher pertama yang punya nominal terbesar
    const bestIndex = vouchers.findIndex((v) => v?.purpose?.toUpperCase() === type?.toUpperCase() && v.nominal_voucher === maxVoucher && maxVoucher > 0);

    let picked = false;

    const bestVouchers = vouchers.map((voucher, index) => {
      const samePurpose = voucher?.purpose?.toUpperCase() === type?.toUpperCase();
      if (!samePurpose) {
        return voucher;
      }

      if (index === bestIndex && !picked) {
        // hanya 1 voucher terbaik yang aktif
        picked = true;
        return {
          ...voucher,
          is_use: true,
          disabled: false,
        };
      }
  
      // voucher lain → disable
      return {
        ...voucher,
        is_use: false,
        nominal_voucher: 0,
        applied_products: [],
        disabled: true,
      };
    });
    return bestVouchers;
  };

  const autoApplyVoucherGlobalForProduct = async (voucher = []) => {
    if (!voucher?.length) return [];
    console.log("autoApplyVoucherGlobal");

    const vouchersList = [];
    for (let vg of voucher || []) {
      let validation = {};
      if (!vg?.referral && vg?.purpose?.toUpperCase() === VOUCHER_GLOBAL_PURPOSE.PRODUCT) {
        validation = await validationVoucherGlobalForProduct(vg);
      }
      vouchersList?.push({ ...vg, ...validation });
    }

    const sorted = sortVouchers(vouchersList);
    const best = applyBestVoucher(sorted, VOUCHER_GLOBAL_PURPOSE.PRODUCT);
    return best;
  };

  const autoApplyVoucherGlobalForDelivery = async (voucher = []) => {
    if (!voucher?.length) return [];
    console.log('autoApplyVoucherGlobalForDelivery');
		const vouchersList = [];
		for (let vg of voucher || []) {
			let validation = {}
			if (!vg?.referral && vg?.purpose?.toUpperCase() === VOUCHER_GLOBAL_PURPOSE.DELIVERY) {
				validation = await validationVoucherGlobalForDelivery(vg);
     	}
			vouchersList?.push({ ...vg, ...validation });
		}

    const sorted = sortVouchers(vouchersList);
    const best = applyBestVoucher(sorted, VOUCHER_GLOBAL_PURPOSE.DELIVERY);
    setVoucherGlobalList(best)  
  }

  const updateAutoApplyB2bVoucher = async (voucherB2b = []) => {
    if (!voucherB2b?.length) return [];
    console.log("updateAutoApplyB2bVoucher");

    const b2bVouchersList = [];

    for (let b2b of b2bVoucherList) {
      let totalIsUse = 0;
      b2bVouchersList.push({ ...b2b, total_is_use: totalIsUse });
    }
    setB2bVoucherList(b2bVouchersList);
  };

  useMemo(() => {
    if (isLoadingVoucherList || !cart?.subTotal) return;
    updateAutoApplyB2bVoucher(b2bVoucherList);
  }, [cart?.subTotal]);

  const handleApplyB2BVoucher = () => {
    console.log("handleApplyB2BVoucher");

    const b2bList = [];

    let remainingNominal = Math.max(
      0,
      Number(cart?.subTotal) - paymentSummary?.fixTotalVoucherNominal
    );

    for (let b2b of b2bVoucherList) {
      let totalIsUse = 0;
      const availableStock = b2b?.total_stock_available || 0;
      const maxNominalUsage = Math.floor(remainingNominal / b2b.nominal);

      totalIsUse = Math.min(availableStock, maxNominalUsage);

      if (totalIsUse > 0) {
        remainingNominal -= totalIsUse * b2b.nominal;
      }

      b2bList.push({ ...b2b, total_is_use: totalIsUse });
    }
    setB2bVoucherList(b2bList);
  };

  const handleGetVoucherGlobalList = async () => {
    if (!cart?.store?.posID || !user?.token || !user?.refresh_token) return;
    console.log("handleGetVoucherGlobalList");
    try {
      setisLoadingVoucherList(true);

      const postDataVg = {
        brand_id: cart?.store?.outletBrandID || null,
        outlet_id: cart?.store?.storeID || null,
        category_id: [],
        product_id: [],
        total_order: totalOrder,
        birthday_date: null,
        total_transaction: null,
        page: 1,
        limit: 100
      };
      const vgUrl = "voucher-global/list";
      const resVg = await axiosInstance.post(vgUrl, postDataVg, {
        headers: {
          "Content-Type": "application/json",
          ...authHeaders().headers
        },
        timeout: 10 * 1000
      });
      if (resVg?.data?.status === "ok") {
        const voucher = await autoApplyVoucherGlobalForProduct(
          resVg?.data?.data?.data || []
        );
        setVoucherGlobalList(voucher);
      }

      setisLoadingVoucherList(false);
    } catch (error) {
      console.log("error: ", error);
      setisLoadingVoucherList(false);
    }
  };

  const handleGetB2BVoucherList = async () => {
    if (!cart?.store?.posID || !user?.token || !user?.refresh_token) return;
    console.log("handleGetB2BVoucherList");
    try {
      setisLoadingVoucherList(true);

      let voucherB2B = [];

      const postDataB2B = {
        merchantCode: cart?.store?.merchantCode ?? "",
        page: 1,
        limit: 10
      };
      const b2bUrl = `voucher-b2b/list`;
      const resB2B = await axiosInstance.post(
        b2bUrl,
        qs.stringify(postDataB2B),
        { timeout: 10 * 1000, ...authHeaders() }
      );
      if (resB2B?.data?.status === "ok") {
        voucherB2B = resB2B?.data?.data || [];
      }

      const groupB2BVoucher = await groupByNominal(voucherB2B);
      const sortedB2BVouchers = groupB2BVoucher?.sort(
        (a, b) => a.nominal - b.nominal
      );
      setB2bVoucherList(sortedB2BVouchers);

      setisLoadingVoucherList(false);
    } catch (error) {
      console.log("error: ", error);
      setisLoadingVoucherList(false);
    }
  };

  const handleUpdateVoucherList = async (
    id,
    voucher_type,
    use = false,
    type = "plus",
    purpose = null
  ) => {
    const updateB2BVoucher = (voucherArray) => {
      console.log("updateB2BVoucher");
      return voucherArray.map((voucher) => {
        let totalIsUse = voucher.total_is_use || 0;
        if (voucher.code === id && type === "plus") {
          totalIsUse += 1;
        }
        if (voucher.code === id && type === "minus") {
          totalIsUse -= 1;
        }
        return {
          ...voucher,
          total_is_use: Math.max(0, totalIsUse)
        };
      });
    };

    const updateVoucherGlobal = async (voucherArray) => {
      console.log("updateVoucherGlobal");

      let updatedList = await Promise.all(
        voucherArray.map(async (voucher) => {
          let validation = voucher;
          if (voucher?.purpose?.toUpperCase() === VOUCHER_GLOBAL_PURPOSE.PRODUCT) {
            validation = await validationVoucherGlobalForProduct(voucher);            
          }

          if (voucher?.purpose?.toUpperCase() === VOUCHER_GLOBAL_PURPOSE.DELIVERY && purpose?.toUpperCase() === VOUCHER_GLOBAL_PURPOSE.DELIVERY) {
            if (isEmptyData(values?.deliveryType)) {
              showError({
                title: 'Piih Pengiriman Terlebih Dahulu',
              });
              return voucher;
            };
            validation = await validationVoucherGlobalForDelivery(voucher);
          }

          let isUse = voucher.is_use ?? false;
          if (voucher.id === id) {
            isUse = !use;
          }

          return {
            ...voucher,
            ...validation,
            is_use: isUse
          };
        })
      );

      const pickedByPurpose = updatedList.reduce((acc, v) => {
        if (v.is_use) {
          acc[v.purpose?.toUpperCase()] = v.id;
        }
        return acc;
      }, {});
      
      updatedList = updatedList.map(v => {
        const p = v.purpose?.toUpperCase();
        const pickedId = pickedByPurpose[p];

        // tidak ada voucher dipilih pada purpose ini
        if (!pickedId) {
          return {
            ...v,
            disabled: false,
          };
        }

        // voucher yang dipilih
        if (v.id === pickedId) {
          return {
            ...v,
            disabled: false,
          };
        }

        // voucher lain dengan purpose yang sama
        return {
          ...v,
          is_use: false,
          nominal_voucher: 0,
          applied_products: [],
          disabled: true,
        };
      });

      return updatedList;
    };

    const updateLoyaltyVoucher = (voucherArray) => {
      console.log('updateLoyaltyVoucher');
      return voucherArray.map((voucher) => {
        let isUse = voucher.is_use ?? false;
        if (voucher.id === id) {
          isUse = !use;
        }

        return {
          ...voucher,
          is_use: isUse
        };
      });

    }

    if (voucher_type === "b2b_voucher") {
      const updatedList = updateB2BVoucher(b2bVoucherList);
      setB2bVoucherList(updatedList);
    }

    if (voucher_type === "voucher_global") {
      const updatedList = await updateVoucherGlobal(voucherGlobalList);
      setVoucherGlobalList(updatedList);
    }

    if (voucher_type === "loyalty_voucher") {
      const updatedList = await updateLoyaltyVoucher(loyaltyVoucherList);
      setLoyaltyVoucherList(updatedList);
    }
    setDataVoucherWarning(null);
  };

  const totalVoucherGlobalNominal = (voucherGlobalList) => {
    if (!voucherGlobalList?.length) return;
    console.log("totalVoucherGlobalNominal");
    const filterVoucherGlobal = voucherGlobalList?.filter(
      (voucher) => voucher.is_use
    );
    const totalVGNominal = filterVoucherGlobal?.reduce(
      (sum, voucher) => sum + voucher.nominal_voucher,
      0
    );
    return totalVGNominal;
  };

  const totalVoucherLoyaltyNominal = (voucherLoyaltyList) => {
    if (!voucherLoyaltyList?.length) return;
    console.log("totalVoucherLoyaltyNominal");
    const filterVoucherLoyalty = voucherLoyaltyList?.filter(
      (voucher) => voucher.is_use
    );
    const totalVLNominal = filterVoucherLoyalty?.reduce(
      (sum, voucher) => sum + voucher.nominal,
      0
    );
    return totalVLNominal;
  };

  const totalB2BVoucherNominal = (voucherList) => {
    if (!voucherList?.length) return;
    console.log("totalB2BVoucherNominal");
    let totalB2BNominal = 0;
    b2bVoucherList.forEach((voucher) => {
      if (voucher.total_is_use) {
        for (let i = 0; i < voucher.total_is_use; i++) {
          totalB2BNominal += voucher.nominal;
        }
      }
    });
    return totalB2BNominal;
  };

  const totalB2BVoucherPrice = (voucherList) => {
    if (!voucherList?.length) return;
    console.log("totalB2BVoucherPrice");
    let totalB2BPrice = 0;
    b2bVoucherList.forEach((voucher) => {
      if (voucher.total_is_use) {
        for (let i = 0; i < voucher?.total_is_use; i++) {
          totalB2BPrice += voucher?.price_user;
        }
      }
    });
    return totalB2BPrice;
  };

  const validationMultipleVoucherGlobal = (vouchers = [], data = null) => {
    if (!vouchers?.length) return [];
    console.log("validationMultipleVoucherGlobal");
    const totalUsedVoucher = vouchers.filter((v) => v?.is_use === true).length;
    console.log("totalUsedVoucher: ", totalUsedVoucher);
    if (totalUsedVoucher > 1) {
      setIsShowWarningRedeem(true);
      setDataVoucherWarning(data);
      return setDataVoucherRedeem(vouchers);
    }
    return setVoucherGlobalList(vouchers);
  };

  const handleVerifyRedeemVoucherGLobal = (verify = false) => {
    console.log("handleVerifyRedeemVoucherGLobal");
    const redeemPurpose = cleanText(dataVoucherWarning?.purpose);
    const updatedList = dataVoucherRedeem?.map((voucher) => {
      const isCurrentVoucher = voucher?.id === dataVoucherWarning?.id;
      const voucherPurpose = cleanText(voucher?.purpose);
      if (verify) {
				if (redeemPurpose == voucherPurpose) {
					return isCurrentVoucher
						? {
								...voucher,
								is_use: true,
								disabled: false,
						}
						: {
								...voucher,
								is_use: false,
								nominal_voucher: 0,
								applied_products: [],
								disabled: true,
						};	
				} else {
					return voucher;
				}
			}

      if (isCurrentVoucher) {
        return {
          ...voucher,
          is_use: false,
          nominal_voucher: 0,
          applied_products: [],
          disabled: true
        };
      }

      return voucher;
    });

    setIsShowWarningRedeem(false);
    setDataVoucherWarning(null);
    setDataVoucherRedeem(null);
    return setVoucherGlobalList(updatedList);
  };

  const handleRedeemVoucherGlobal = async (data = null) => {
    console.log("handleRedeemVoucherGlobal");

    let updatedList = [...(voucherGlobalList || [])];

    const existsIndex = updatedList.findIndex((v) => v.id === data?.id);

    if (existsIndex >= 0) {
      updatedList[existsIndex] = {
        ...updatedList[existsIndex],
        referral: 0
      };
    } else {
      updatedList.push({
        ...data,
        referral: 0
      });
    }

    if (data?.purpose === VOUCHER_GLOBAL_PURPOSE.DELIVERY && isEmptyData(values?.deliveryType)) {
      showError({
        title: 'Piih Pengiriman Terlebih Dahulu',
      });
    }

    let appliedVoucher = data;
    if (data?.purpose === VOUCHER_GLOBAL_PURPOSE.PRODUCT) {
      appliedVoucher = await validationVoucherGlobalForProduct(data);
    }
    if (data?.purpose === VOUCHER_GLOBAL_PURPOSE.DELIVERY && !isEmptyData(values?.deliveryType)) {
      appliedVoucher = await validationVoucherGlobalForDelivery(data);
    }

    updatedList = updatedList.map((v) =>
      v?.id === data?.id ? { ...appliedVoucher, ...v } : v
    );
    validationMultipleVoucherGlobal(updatedList, data);
  };

  const totalNominalVoucherGlobal = useMemo(() => {
    return totalVoucherGlobalNominal(voucherGlobalList) || 0;
  }, [voucherGlobalList]);

  const totalNominalVoucherLoyalty = useMemo(() => {
    return totalVoucherLoyaltyNominal(loyaltyVoucherList) || 0;
  }, [loyaltyVoucherList]);

  const totalNominalB2BVoucher = useMemo(() => {
    return totalB2BVoucherNominal(b2bVoucherList) || 0;
  }, [b2bVoucherList]);

  const totalPriceB2BVoucher = useMemo(() => {
    return totalB2BVoucherPrice(b2bVoucherList) || 0;
  }, [b2bVoucherList]);

  const maxNominalVoucher = useMemo(() => {
    let subTotal = Number(cart?.subTotal)
		if (Number(values?.deliveryType?.amount) > 0) {
			subTotal += Number(values?.deliveryType?.amount)
		}
    return Number(totalNominalB2BVoucher) + Number(totalNominalVoucherGlobal) + Number(totalNominalVoucherLoyalty) >
      Number(subTotal)
      ? Number(subTotal)
      : Number(totalNominalB2BVoucher) + Number(totalNominalVoucherGlobal) + Number(totalNominalVoucherLoyalty);
  }, [totalNominalB2BVoucher, totalNominalVoucherGlobal, totalNominalVoucherLoyalty, cart?.subTotal]);

  const remainingNominal = useMemo(() => {
    return Number(cart?.subTotal) - Number(maxNominalVoucher);
  }, [cart?.subTotal, maxNominalVoucher]);

  const paymentSummary = useMemo(() => {
		const addonPackagingFee = Number(cart?.store?.addonPackagingFee || 0);
		const minAddonPackagingFee = Number(cart?.store?.minAddonPackagingFee || 0);
    const outletPackagingFee = Number(cart?.store?.outletPackagingFee || 0);
    // const deliveryPackagingFee = Number(cart?.store?.deliveryPackagingFee || 0);
		// const pickupPackagingFee = Number(cart?.store?.pickupPackagingFee || 0);
		// const dineinPackagingFee = Number(cart?.store?.dineinPackagingFee || 0);
		const subTotal = Number(cart?.subTotal || 0);
		const platformFee = Number(cart?.platformFee || 0);
		const deliveryFee = values?.orderType === 'delivery' ? Number(values?.deliveryType?.amount || 0) + Number(values?.deliveryFee) : 0;

    let companyOnlineFee = 0;
    let onlineFee = 0;
    let packagingFee = outletPackagingFee;

    switch (nameOrderType) {
      case "delivery":
        companyOnlineFee = Number(cart?.onlineFeeDelivery || 0);
        // packagingFee = deliveryPackagingFee;
        break;
      case "pickup":
        companyOnlineFee = Number(cart?.onlineFeePickup || 0);
        // packagingFee = pickupPackagingFee;
        break;
      case "dinein":
        companyOnlineFee = Number(cart?.onlineFeeDinein || 0);
        // packagingFee = dineinPackagingFee;
        break;
      default:
        companyOnlineFee = 0;
        break;
    }

    if (companyOnlineFee > 0) {
      onlineFee = Math.round(subTotal * (companyOnlineFee / 100));
    }

		if (addonPackagingFee !== 0 && cart?.totalItem >= minAddonPackagingFee) {
			packagingFee += calculateAddonPackagingFee(addonPackagingFee, minAddonPackagingFee, cart?.totalItem);
		}

		const isDisableVoucher = totalNominalB2BVoucher > subTotal;
		const fixTotalVoucherNominal = isDisableVoucher ? subTotal : maxNominalVoucher;

		const outletTax = outlet?.outlet_tax ? parseFloat(outlet?.outlet_tax) / 100 : 0;
		const outletPb1 = outlet?.outlet_pb1 ? parseFloat(outlet?.outlet_pb1) / 100 : 0;
		const tax = Math.round(subTotal * outletTax);
		const totalAfterTax = subTotal + tax;
		const pb1 = Math.round(totalAfterTax * outletPb1);

		const prevTotalPayment = subTotal + pb1 + tax + packagingFee + platformFee + deliveryFee + onlineFee + totalPriceB2BVoucher - fixTotalVoucherNominal;

		const selectedPaymentType = values?.paymentType;
		const feeNominal = Number(selectedPaymentType?.fee || 0);
		const feePercent = Number(selectedPaymentType?.fee_percent || 0);
		let paymentFee = feePercent > 0 ? prevTotalPayment * (feePercent / 100) : feeNominal;
    paymentFee = Math.round(paymentFee);

		const otherFee = packagingFee + platformFee + paymentFee + onlineFee;

		const updatePaymentFee = subTotal + packagingFee + platformFee + deliveryFee + totalPriceB2BVoucher - fixTotalVoucherNominal;

    const totalPayment = prevTotalPayment + paymentFee;

    const strikeOutTotal = cart?.item?.reduce((total, item) => {
			const itemUnitCost = Number(item?.itemUnitCost) || 0;
			const itemUnitPrice = Number(item?.itemUnitPrice) || 0;
			const itemQuantity = Number(item?.itemQuantity) || 0;

			if (item?.productType === '1') {
				return total + itemUnitCost * itemQuantity;
			}

			if (item?.productType === '2') {
				if (item?.comboset?.length === 0) {
					return total + itemUnitPrice * itemQuantity;
				}
				const comboPrice =
					item?.comboset?.reduce(
						(comboTotal, combo) =>
							comboTotal +
							(combo?.productDetails?.reduce(
								(detailTotal, detail) =>
									detailTotal +
									(Number(detail?.productPrice) || 0) *
										(Number(detail?.quantity) || 0),
								0
							) || 0),
						0
					) || 0;
				return total + comboPrice + (itemUnitCost - itemUnitPrice);
			}

			return total + itemUnitPrice * itemQuantity;
		}, 0);
    const strikeDiscount = (strikeOutTotal - subTotal) + fixTotalVoucherNominal;

		return {
			subTotal: subTotal,
			totalPayment: totalPayment,
			deliveryFee: deliveryFee,
			fixTotalVoucherNominal: fixTotalVoucherNominal,
			otherFee: otherFee,
			packagingFee: packagingFee,
			platformFee: platformFee,
			paymentFee: paymentFee,
			isDisableVoucher: isDisableVoucher,
			updatePaymentFee,
			tax,
			pb1,
      onlineFee,
      strikeOutTotal: strikeOutTotal,
      strikeDiscount: strikeDiscount,
		};
  }, [cart, values?.deliveryType?.amount, values?.deliveryFee, values?.paymentType, b2bVoucherList, totalNominalB2BVoucher, maxNominalVoucher, outlet?.outlet_tax, outlet?.outlet_pb1, values?.orderType]);

  useEffect(() => {
    setPaymentMethodList([]);
  }, []);

  useEffect(() => {
    handleGetPaymentFee();
  }, [paymentSummary?.updatePaymentFee]);

  const suggestAutoB2BVoucher = () => {
    if (!b2bVoucherList?.length || !cart?.subTotal || totalNominalB2BVoucher)
      return;
    console.log("suggestAutoB2BVoucher");

    let totalB2BNominal = 0;
    let totalB2BPrice = 0;

    let remainingNominal = Math.max(
      0,
      Number(cart?.subTotal) - paymentSummary?.fixTotalVoucherNominal
    );

    for (let b2b of b2bVoucherList) {
      let totalIsUse = 0;
      const availableStock = b2b?.total_stock_available || 0;
      const maxNominalUsage = Math.floor(remainingNominal / b2b.nominal);

      totalIsUse = Math.min(availableStock, maxNominalUsage);

      if (totalIsUse > 0) {
        totalB2BNominal += totalIsUse * b2b.nominal;
        totalB2BPrice += totalIsUse * b2b.price_user;
        remainingNominal -= totalIsUse * b2b.nominal;
      }
    }

    const b2BVoucherSaved = Math.max(0, totalB2BNominal - totalB2BPrice);
    return b2BVoucherSaved;
  };

  const totalSavedB2BVoucher = useMemo(() => {
    return suggestAutoB2BVoucher() || 0;
  }, [b2bVoucherList, cart?.subTotal, paymentSummary?.fixTotalVoucherNominal]);

  const getMatchedData = (method = {}, dataPg = []) => {
    const mapping = method.mapping || {};
    const keys = Object.keys(mapping);

    const orderedKeys = [
      user?.paymentMethod,
      ...keys.filter((key) => key !== user?.paymentMethod)
    ];

    for (const key of orderedKeys) {
      const match = mapping[key];
      if (!match) continue;

      const { code, source } = match;

      const data = dataPg[code];

      if (data) {
        return {
          ...method,
          code,
          source,
          id: data?.id_payment_method ?? null,
          fee: data.fee ?? method.fee,
          fee_percent: data?.fee_percent ?? 0,
          minimum_amount: data.minimum_amount ?? method.minimum_amount,
          maximum_amount: data.maximum_amount ?? method.maximum_amount,
          status: data.status ?? method.status
        };
      }
    }

    return null;
  };

  const handleGetPaymentFee = async () => {
    try {
      setisLoadingPaymentMethodList(true);

      const resPg = await axiosInstance.get(`/payment-gateway/payment-methods`, authHeaders());
      const apiData = resPg?.data?.data || [];

      const mappedMethods = apiData.map((item) => {
        const uiConfig = PAYMENT_UI_CONFIG[item?.code] || {
          image_size: 'w-10 h-auto',
          image_size_payment: 'w-14 h-auto',
        };

        return {
          id: item?.id_payment_method,
          event: `payment_methods_select_${item?.code?.toLowerCase()}`,
          code: item?.code,
          name: item?.name,
          minimum_amount: Number(item?.minimum_amount || 0),
          maximum_amount: Number(item?.maximum_amount || 0),
          status: 'ACTIVE',
          fee: Number(item?.fee || 0),
          fee_percent: Number(item?.fee_percent || 0),
          image_url: item?.image_url?.replace(/'/g, '') || '',
          image_size: uiConfig?.image_size,
          image_size_payment: uiConfig?.image_size_payment,
          mapping: {
            pg: {
              source: 'pg',
              code: item?.code,
            },
          },
          type: item?.type,
        };
      });

      let currentPaymentType = null;

      const updatedPaymentMethodList = listPaymentMethod
        ?.map((category) => {
          const filteredMethods = mappedMethods.filter((method) => {
            if (category.category === 'Other Payment Method') {
              return method.type === 'qris' || method?.type === 'ewallet';
            }
            if (category.category === 'Virtual Account') {
              return method.type === 'virtual_account';
            }
            return false;
          });

          // set default selected
          filteredMethods.forEach((method) => {
            if (!currentPaymentType && user?.paymentMethod === 'pg') {
              currentPaymentType = method;
            }
            if (!currentPaymentType) {
              currentPaymentType = method;
            }
          });

          return {
            ...category,
            payment_method: filteredMethods,
          };
        })
        .filter((category) => category.payment_method.length);
      setPaymentMethodList(updatedPaymentMethodList);

      if (currentPaymentType) {
        setDefaultValues((prev) => ({
          ...prev,
          paymentType: currentPaymentType,
        }));
      }

      setisLoadingPaymentMethodList(false);
    } catch (error) {
      console.log('error: ', error);
      setisLoadingPaymentMethodList(false);
    }
  };

  const processB2BVouchers = (b2bVoucherList = []) => {
    console.log("processB2BVouchers");
    let result = [];

    b2bVoucherList.forEach((voucher) => {
      if (voucher.total_is_use) {
        for (let i = 0; i < voucher.total_is_use; i++) {
          let newVoucher = { ...voucher };
          delete newVoucher.total_is_use;
          delete newVoucher.total_stock_available;
          result.push({
            voucher_name: newVoucher?.name,
            voucher_code: newVoucher?.code,
            voucher_nominal: newVoucher?.nominal,
            voucher_price: newVoucher?.price,
            voucher_merchant_code: newVoucher?.merchant_code,
            voucher_qty: 1,
            voucher_price_user: newVoucher?.price_user
          });
        }
      }
    });

    return result;
  };

  const instruction = useMemo(() => {
    const headerNote = `Proses Penyiapan Makanan: estimasi 15-25 menit.\n\n`;
    const deliveryNote = `Delivery Note:\n - No Order: ${values?.orderLocalNumber}\n\n`;
    let pickupNote = `Nota Pengambilan:\n`;
    if (cart?.store?.storeName) {
      pickupNote += `- ${cart?.store?.storeName}\n`;
    }
    if (cart?.store?.floor) {
      pickupNote += `- Ambil di Lantai ${cart?.store?.floor}\n`;
    }
    if (cart?.store?.unit) {
      pickupNote += `- Unit ${cart?.store?.unit}\n`;
    }
    pickupNote += `- Depan Kasir`;
    const menuItems = cart?.item
      ?.map((item) => {
        let menuItem = `  ${item?.itemName}: ${item?.itemQuantity} quantity`;
        if (item?.comboset?.length) {
          const combo = item?.comboset?.map((comboset) => {
            const name = `\n  - ${comboset?.comboSetname}:`;
            const combo = comboset?.productDetails?.map((detail) => {
              return `\n      ${detail?.productName}`;
            });
            return `${name}${combo}`;
          });
          menuItem += `  ${combo}`;
        }
        if (item?.itemNotes) {
          menuItem += `\n  - Notes: ${item?.itemNotes}`;
        }
        return menuItem;
      })
      .join("\n");
    const customerInfo = `\n\nCustomer:\n${user?.firstName} ${user?.lastName ?? ""}\n${addCountryCode(String(user?.primary_phone))}`;
    const deliveryNotes = `${user?.detail ?? "-"} ${values?.notes ?? "-"}`;
    const notes = `*Jika tidak dapat menghubungi customer, silakan hubungi CS UFood di +62 81111801081`;
    return `${headerNote}${deliveryNote}${pickupNote}\n\nMenu Dipesan:\n${menuItems}${customerInfo}\n${deliveryNotes}\n\n${notes}`;
  }, [values, cart, user]);

  const handleCreateDelivery = async () => {
    console.log("handleCreateDelivery");

    const payload = {
      unquieid: values?.unquieid,
      instantOrder: values?.instantOrder,
      availabilityID: values?.availabilityID,
      availabilityName: values?.availabilityName,
      orderSource: values?.orderSource,
      firstName: values?.destinations?.recipient?.firstName,
      email: values?.destinations?.recipient?.email ?? "",
      phone: values?.destinations?.recipient?.phone,
      lastName: values?.destinations?.recipient?.lastName,
      address: values?.destinations?.address,
      destinationDetail: values?.destinations?.recipient?.detail,
      village: values?.destinations?.village,
      district: values?.destinations?.district,
      city: values?.destinations?.city,
      state: values?.destinations?.state,
      country: values?.destinations?.country,
      latitude: values?.destinations?.coordinate?.latitude,
      longitude: values?.destinations?.coordinate?.longitude,
      postalCode: values?.destinations?.postalCode,
      billingaddress: values?.origin?.address,
      storeID: values?.origin?.storeID,
      items: (cart?.item || [])?.map((p) => p?.itemName).join(", "),
      deliveryPartner: {
        name: values?.deliveryType?.name,
        serviceType: values?.deliveryType?.serviceType,
        vehicleType: values?.deliveryType?.vehicleType,
        amount: values?.deliveryType?.amount,
        distance: values?.deliveryType?.distance,
        deliveryPartnerId: values?.deliveryType?.deliveryPartnerId,
        normal_amount: values?.deliveryType?.normal_amount,
        subsidy: values?.deliveryType?.subsidy
      },
      deliveryFee: values?.deliveryFee,
      deliverySubsidies: values?.deliverySubsidies,
      instruction: instruction
    };

    const urlDelivery = `delivery/create`;
    const orderDelivery = await axiosInstance.post(
      urlDelivery,
      JSON.stringify(payload),
      {
        baseURL: apiUrlB2B,
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          ...authHeaders().headers
        }
      }
    );

    if (orderDelivery?.data?.status !== "ok") {
      console.log("orderDelivery b2b: ", orderDelivery);
      if (orderDelivery?.data?.message?.responseMessage?.toLowerCase() === "toko tutup") {
        return setShowClosed(true);
      }
      showError({
        title: orderDelivery?.data?.message?.responseMessage,
      });
      handleGetPathnerList();
      return setIsLoading(false);
    }
    return orderDelivery?.data?.data?.deliveryOrderID;
  };

  const handleNavigatePayment = (createPayment = null) => {
    console.log("handleNavigatePayment: ", createPayment);
    const data = createPayment?.data?.data;
    const unixtime =
      typeof data?.expired_at === "string"
        ? dateToUnix(data?.expired_at)
        : data?.expired_at;
    const paymentData = {
      ...data,
      session_token: createPayment?.data?.session_token || null,
      date: moment().tz("Asia/Jakarta").format("YYYY-MM-DD HH:mm:ss"),
      expired_date: unixToDate(unixtime),
      timeLeft: getSecondsLeft(unixtime),
      qr_image_url: data?.qr_image_url || null
    };
    dispatch(setPayment(paymentData));

    navigate.push(`${UFOODX_BASE_URL}/payment`);
  };

  const handleCreatePayment = async (deliveryOrderID = null) => {
    console.log("handleCreatePayment");
    const b2bVoucher = processB2BVouchers(b2bVoucherList);
    const vgVoucher =
      voucherGlobalList
        ?.filter((voucher) => voucher.is_use)
        ?.map((voucher) => voucher) || [];
    const loyaltyVoucher =
      loyaltyVoucherList
        ?.filter((voucher) => voucher.is_use)
        ?.map((voucher) => voucher) || [];

    const selectedPaymentType = values?.paymentType;

    const payload = {
      unquieid: values?.unquieid,
      taxCharge: values?.taxCharge,
      taxAmount: values?.taxAmount,
      subTotal: paymentSummary?.subTotal,
      grandTotal: paymentSummary?.totalPayment,
      totalDiscount: values?.totalDiscount,
      discountType: values?.discountType,
      totalItem: cart?.item?.length || 0,
      instantOrder: values?.instantOrder,
      availabilityID: values?.availabilityID,
      availabilityName: values?.availabilityName,
      orderSource: 'ufoodx',
      firstName: values?.destinations?.recipient?.firstName,
      email: values?.destinations?.recipient?.email ?? "",
      phone: values?.destinations?.recipient?.phone,
      lastName: values?.destinations?.recipient?.lastName,
      address: values?.destinations?.address,
      destinationDetail: `${values?.destinations?.recipient?.detail || "-"} ${values?.notes ?? "-"}`,
      village: values?.destinations?.village,
      district: values?.destinations?.district,
      city: values?.destinations?.city,
      state: values?.destinations?.state,
      country: values?.destinations?.country,
      postalCode: values?.destinations?.postalCode,
      billingaddress: values?.origin?.address,
      storeID: values?.origin?.storeID,
      brandID: values?.origin?.outletBrandID,
      items: (cart?.item || [])?.map((item) => {
        return {
          itemID: item?.itemID,
          product_primary_id: item?.product_primary_id,
          product_category_id: item?.product_category_id,
          productID: item?.productID,
          itemName: item?.itemName,
          itemSKU: item?.itemSKU,
          itemImage: item?.itemImage,
          itemQuantity: item?.itemQuantity,
          itemNotes: item?.itemNotes,
          comboset: item?.comboset?.map((combo) => {
            return {
              ...combo,
              productDetails: combo?.productDetails?.map((detail) => {
                return {
                  productID: detail?.productID,
                  productName: detail?.productName,
                  productSKU: detail?.productSKU,
                  quantity: detail?.quantity,
                  product_primary_id: detail?.product_primary_id
                };
              })
            };
          }),
          productType: item?.productType
        };
      }),
      deliveryPartner: {
        name: values?.deliveryType?.name,
        serviceType: values?.deliveryType?.serviceType,
        vehicleType: values?.deliveryType?.vehicleType,
        amount: values?.deliveryType?.amount,
        distance: values?.deliveryType?.distance,
        deliveryPartnerId: values?.deliveryType?.deliveryPartnerId,
        normal_amount: values?.deliveryType?.normal_amount,
        subsidy: values?.deliveryType?.subsidy
      },
      paymentFee: paymentSummary?.paymentFee || 0,
      paymentMethod: selectedPaymentType?.code || "",
      payment: selectedPaymentType,
      paymentReferenceID: values?.paymentReference,
      packagingFee: paymentSummary?.packagingFee,
      platformFee: paymentSummary?.platformFee,
      additionalDeliveryCharge: values?.additionalDeliveryCharge,
      deliveryFee: values?.deliveryFee,
      deliverySubsidies: values?.deliverySubsidies,
      token: user?.token,
      b2b_voucher: b2bVoucher,
      voucher_global: vgVoucher,
      loyalty_voucher: loyaltyVoucher,
      pin: values?.pin || null,
      tax: paymentSummary?.tax || 0,
      pb1: paymentSummary?.pb1 || 0,
      totalPriceB2BVoucher: totalPriceB2BVoucher || 0,
      totalNominalB2BVoucher: totalNominalB2BVoucher,
      totalNominalVoucherGlobal: totalNominalVoucherGlobal,
      totalNominalVoucherLoyalty: totalNominalVoucherLoyalty,
      fixTotalVoucherNominal: paymentSummary?.fixTotalVoucherNominal || 0,
      deliveryOrderID: deliveryOrderID,
      deviceID: device?.device_id,
      orderTableNumberID: order?.tableNumber?.id,
      orderTableNumber: order?.tableNumber?.table_number,
      loyalty,
      onlineFee: paymentSummary?.onlineFee,
    };

    if (values?.orderType !== "delivery") {
      delete payload.deliveryOrderID;
      delete payload.deliveryPartner;
      payload.deliveryFee = 0;
    }

    payload.orderLocalNumber = values?.orderLocalNumber;
    const urlPayment = `payment/va`;
    const createPayment = await axiosInstance.post(
      urlPayment,
      JSON.stringify(payload),
      {
        baseURL: apiUrlB2B,
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`
        },
        validateStatus: function (status) {
          return status < 500;
        }
      }
    );

    if (createPayment?.data?.status !== "ok") {
      setIsLoading(false);
      console.log("createPayment b2b: ", createPayment);
      if (createPayment?.data?.message?.responseMessage?.toLowerCase() === "toko tutup") {
        return setShowClosed(true);
      }
      return showError({
        title: createPayment?.data?.message?.responseMessage || "Terjadi Kesalah refresh halaman ini",
        description: "Silakan coba metode pembayaran lain untuk menyelesaikan transaksi Anda"
      });
    }

    if (cleanText(values?.orderType) === "dinein") {
      // await dispatch(setOrder({ tableNumber: {} }));
    }

    await dispatch(
      removeCart(),
    );

    return handleNavigatePayment(createPayment);
  };

  const handlePayment = async () => {
    console.log("handlePayment");
    try {
      const minimum = Number(values?.paymentType?.minimum_amount);
      const maximum = Number(values?.paymentType?.maximum_amount);

      if (Number(paymentSummary?.totalPayment) < minimum) {
        return showError({
          title: `minimum payment is ${formatRupiah(minimum)}`,
        });
      }

      if (Number(paymentSummary?.totalPayment) > maximum) {
        return showError({
          title: `maximum payment is ${formatRupiah(maximum)}`,
        });
      }

      setIsLoading(true);

      sendAnalyticsCustomEvent("summary", values);
      trackMetaPixelEvent("summary", values);

      let deliveryOrderID = null;
      if (values?.orderType === "delivery") {
        deliveryOrderID = await handleCreateDelivery();
      }

      await handleCreatePayment(deliveryOrderID);

      setIsLoading(false);
    } catch (error) {
      console.log("error: ", error);
      setIsLoading(false);
      if (error?.response?.data?.message.toLowerCase() === "toko tutup") {
        return setShowClosed(true);
      }
      showError({
        title: error?.response?.data?.message || error?.message || ""
      });
    }
  };

  const handleVoucherDetail = (isShow, data, type = null) => {
    if (isShow) {
      setShowVoucherDetail({
        isOpen: true,
        data,
        type
      });
    } else {
      setShowVoucherDetail({
        isOpen: false,
        data: null,
        type: null
      });
    }
  };

  const groupB2BForTooltip = (b2bVoucherList = []) => {
    if (!b2bVoucherList?.length) return [];
    console.log("groupB2BForTooltip");
    const listUseB2BVoucher =
      b2bVoucherList?.filter((voucher) => voucher.total_is_use) || [];

    const result = [];

    listUseB2BVoucher?.forEach((voucher) => {
      const existingVoucher = result.find((v) => v.nominal === voucher.nominal);

      if (existingVoucher) {
        existingVoucher.total += voucher?.total_is_use;
      } else {
        result.push({
          name: voucher?.name,
          desc: "Purchase voucher available at related merchants.",
          total: voucher?.total_is_use,
          nominal: voucher?.nominal
        });
      }
    });

    return result;
  };

  const groupLoyaltyForTooltip = (loyaltyVoucherList = []) => {
    if (!loyaltyVoucherList?.length) return [];
    console.log("groupLoyaltyForTooltip");
    const listUseLoyaltyVoucher =
      loyaltyVoucherList?.filter((voucher) => voucher.is_use) || [];

    const result = [];

    listUseLoyaltyVoucher?.forEach((voucher) => {
      const existingVoucher = result.find((v) => v.nominal === voucher.nominal);

      if (existingVoucher) {
        existingVoucher.total += 1;
      } else {
        result.push({
          name: voucher?.name,
          desc: "Purchase voucher available at related merchants.",
          total: voucher?.total ?? 1,
          nominal: voucher?.nominal
        });
      }
    });

    return result;
  };

  const groupVGForTooltip = (voucherGlobalList = []) => {
    if (!voucherGlobalList?.length) return [];
    console.log("groupVGForTooltip");
    const listUseVoucherGlobal =
      voucherGlobalList?.filter((voucher) => voucher.is_use) || [];

    const result = [];

    listUseVoucherGlobal?.forEach((voucher) => {
      const existingVoucher = result.find((v) => v.code === voucher.code);

      if (existingVoucher) {
        existingVoucher.total += 1;
      } else {
        result.push({
          name: voucher?.code,
          desc: "Using the available voucher in voucher global.",
          total: voucher?.total ?? 1,
          nominal: voucher?.nominal_voucher
        });
      }
    });

    return result;
  };

  const tooltipVoucherList = useMemo(() => {
    const groupB2BVoucher = groupB2BForTooltip(b2bVoucherList);
    const groupVGVoucher = groupVGForTooltip(voucherGlobalList);
    const groupLoyaltyVoucher = groupLoyaltyForTooltip(loyaltyVoucherList);
    return [...groupB2BVoucher, ...groupVGVoucher, ...groupLoyaltyVoucher];
  }, [b2bVoucherList, voucherGlobalList, loyaltyVoucherList]);

  const tooltipOtherFee = useMemo(() => {
    const result = [];
    if (paymentSummary?.onlineFee && paymentSummary?.onlineFee > 0) {
      result?.push({
        name: "Online Fee",
        desc: "Biaya pemeliharaan sistem dan layanan aplikasi untuk mendukung kelancaran operasional setiap pesanan Anda.",
        total: null,
        nominal: paymentSummary?.onlineFee
      });
    }
    if (paymentSummary?.packagingFee) {
      result?.push({
        name: "Packaging Fee",
        desc: "Biaya untuk kemasan makanan dan minuman agar tetap aman, rapi, dan higienis selama proses pengemasan.",
        total: null,
        nominal: paymentSummary?.packagingFee
      });
    }
    if (paymentSummary?.platformFee) {
      result?.push({
        name: "Platform Fee",
        desc: "Biaya layanan untuk mendukung operasional platform, termasuk pemprosesan pesanan dan pengembangan fitur agar pengalaman pemesanan tetap lancar.",
        total: null,
        nominal: paymentSummary?.platformFee
      });
    }
    if (paymentSummary?.paymentFee) {
      result?.push({
        name: "Payment Fee",
        desc: "Biaya untuk memproses pembayaran secara aman melalui sistem pembayaran, termasuk biaya dari penyedia layanan pembayaran.",
        total: null,
        nominal: paymentSummary?.paymentFee
      });
    }
    return result;
  }, [
    paymentSummary?.paymentFee,
    paymentSummary?.platformFee,
    paymentSummary?.packagingFee,
    paymentSummary?.onlineFee,
  ]);

  const strikeOutTotalPayment = useMemo(() => {
    return (
      Number(paymentSummary?.subTotal) +
      Number(paymentSummary?.otherFee) +
      Number(paymentSummary?.deliveryFee) +
      Number(paymentSummary?.tax) +
      Number(paymentSummary?.pb1) +
      (Number(paymentSummary?.strikeOutTotal) - Number(paymentSummary?.subTotal))
    );
  }, [
    paymentSummary?.subTotal,
    paymentSummary?.otherFee,
    paymentSummary?.deliveryFee,
    paymentSummary?.tax,
    paymentSummary?.pb1,
    paymentSummary?.strikeOutTotal
  ]);

  const handleCloseBottomSheet = () => {
    console.log("handleCloseBottomSheet");
    setIsShowBottomSheet(false);
    setIsShowDelivery(false);
    setIsShowPaymentMethod(false);
    setIsShowSimpleProduct(false);
    setIsShowComboProduct(false);
    setIsShowVoucher(false);
    setIsShowDeliveryLocation(false);
    setIsTooFar(false);

    document.body.style.overflow = "";
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === "payment-partner") {
        console.log("event: ", event);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const handleGetVouchersLoyalty = async () => {
    try {
      dispatch(getVouchersLoyalty());
    } catch (error) {
      console.log('error: ', error);
    }
  };

  useEffect(() => {
    handleGetVouchersLoyalty();
  }, [])

  useEffect(() => {
    if (isLoadingVoucherLoyalty || isEmptyData(voucherList?.docs)) return;
    setLoyaltyVoucherList(voucherList?.docs || [])
  }, [isLoadingVoucherLoyalty, voucherList?.docs])

  const deliveryOptionProps = useMemo(() => {
    return {
      errors,
      touched,
      values
    };
  }, [errors, touched, values]);

  useEffect(() => {
    const unsubscribe = subscribeError(setErrorOpen);
    return unsubscribe;
  }, []);

  useEffect(() => {
    if (isEmptyData(values?.deliveryType)) return;
    autoApplyVoucherGlobalForDelivery(voucherGlobalList)
  }, [values?.deliveryType, values?.orderType])

  return (
    <>
      {isLoading && <Loader overlay />}
      <div
        className={`flex h-screen w-full justify-center items-center bg-white`}
      >
        <div className="relative h-screen w-full max-w-lg">
          <div className={`absolute mt-4 w-full`}>
            <div className='flex flex-row justify-between mx-4 border-b-1 border-solid pb-2 border-gray-200'>
              <div className='flex justify-center items-center cursor-pointer' onClick={() => navigate.push(`${UFOODX_BASE_URL}/${outlet?.storeSlug}/${nameOrderType}`)} id='summary_back'>
                <ArrowLeftIcon className='h-8 w-8 min-h-8 text-gray-900 p-1.5' />
                <div className='pl-2 text-base text-gray-900 font-semibold truncate max-w-[75vw]'>{cart?.store?.storeName ?? ''}</div>
              </div>
            </div>
            <OrderOption
              isDisabled={isLoading || isLoadingDeliveryList}
              setValues={setValues}
              setDefaultValues={setDefaultValues}
              outletId={cart?.store?.storeID}
            />
            <OutletDetail values={values} />
            <DeliveryOption {...deliveryOptionProps} />
            <NotesOption values={values} setValues={setValues} />
            <DeliveryPartnerOption
              selectedPathner={selectedPathner}
              errors={errors}
              touched={touched}
              values={values}
              isLoadingDeliveryList={isLoadingDeliveryList}
              setValues={setValues}
              setIsShowDelivery={setIsShowDelivery}
              setIsShowBottomSheet={setIsShowBottomSheet}
            />
            <ProductOption
              cart={cart}
              handleGetProductDetail={handleGetProductDetail}
              handleCart={handleCart}
              outlet={outlet}
              order={order}
            />

            {nameOrderType === "dinein" && !isEmptyData(outlet?.dinein_qr_code) && (
              <TableNumber tableNumber={order?.tableNumber?.table_number} />
            )}

            <VoucherOption
              isLoadingVoucherList={isLoadingVoucherList || isLoadingVoucherLoyalty}
              maxNominalVoucher={maxNominalVoucher}
              totalSavedB2BVoucher={totalSavedB2BVoucher}
              handleApplyB2BVoucher={handleApplyB2BVoucher}
              isLoading={isLoading}
              totalNominalB2BVoucher={totalNominalB2BVoucher}
              totalNominalVoucherGlobal={totalNominalVoucherGlobal}
              totalNominalVoucherLoyalty={totalNominalVoucherLoyalty}
              setIsShowBottomSheet={setIsShowBottomSheet}
              setIsShowVoucher={setIsShowVoucher}
            />
            <PaymentOption
              isLoadingPaymentMethodList={isLoadingPaymentMethodList}
              values={values}
              setIsShowPaymentMethod={setIsShowPaymentMethod}
              setIsShowBottomSheet={setIsShowBottomSheet}
            />
            <PaymentSummaryOption
              values={values}
              paymentSummary={paymentSummary}
              tooltipOtherFee={tooltipOtherFee}
              totalNominalB2BVoucher={totalNominalB2BVoucher}
              tooltipVoucherList={tooltipVoucherList}
              maxNominalVoucher={maxNominalVoucher}
              totalPriceB2BVoucher={totalPriceB2BVoucher}
              strikeOutTotalPayment={strikeOutTotalPayment}
            />
            {isShowBottomSheet && (
              <BottomSheet
                open={isShowBottomSheet}
                onDismiss={handleCloseBottomSheet}
                blocking={
                  isShowWarningVoucher || isShowWarningRedeem || errorOpen ? false : true
                }
                snapPoints={({ minHeight, maxHeight }) => {
                  if (isShowDeliveryLocation) {
                    return [maxHeight - maxHeight / 10];
                  }
                  return [minHeight, maxHeight * 0.75];
                }}
                header={() => {
                  return null;
                }}
                footer={
                  isShowVoucher ? (
                    <button
                      id="voucher_submit"
                      className="w-full bg-[var(--rose-violet)] text-white flex justify-center font-normal text-sm border-0 items-center p-3 rounded-lg"
                      onClick={() => {
                        handleCloseBottomSheet();
                      }}
                    >
                      Simpan
                    </button>
                  ) : null
                }
              >
                {isShowSimpleProduct && (
                  <ProductSimple
                    product={cartItem}
                    cart={cart}
                    handleCart={handleCart}
                    setCartItem={setCartItem}
                  />
                )}
                {isShowComboProduct && (
                  <ComboDetail
                    product={product}
                    item={item}
                    handleSubmitItem={handleCart}
                    isEdit={true}
                  />
                )}
                <DeliveryBottomSheet
                  isShowDelivery={isShowDelivery}
                  pathnerList={pathnerList}
                  selectedPathner={selectedPathner}
                  setSelectedPathner={setSelectedPathner}
                  setValues={setValues}
                  setIsShowDelivery={setIsShowDelivery}
                  setIsShowBottomSheet={setIsShowBottomSheet}
                />
                {isShowPaymentMethod && (
                  <PaymentMethod
                    {...{ paymentSummary, paymentMethodList, isShowPaymentMethod, setIsShowPaymentMethod, setIsShowBottomSheet, values, setValues }}
                  />
                )}
                <VoucherBottomSheet
                  isShowVoucher={isShowVoucher}
                  voucherGlobalList={voucherGlobalList}
                  b2bVoucherList={b2bVoucherList}
                  loyaltyVoucherList={loyaltyVoucherList}
                  remainingNominal={remainingNominal}
                  cart={cart}
                  totalOrder={totalOrder}
                  showVoucherDetail={showVoucherDetail}
                  handleVoucherDetail={handleVoucherDetail}
                  handleRedeemVoucherGlobal={handleRedeemVoucherGlobal}
                  handleUpdateVoucherList={handleUpdateVoucherList}
                  setDataVoucherWarning={setDataVoucherWarning}
                  setIsShowWarningVoucher={setIsShowWarningVoucher}
                  {...{ values }}
                />
                {isTooFar && (
                  <TooFar
                    show={isTooFar}
                    handleClickButton={handleCloseBottomSheet}
                  />
                )}
              </BottomSheet>
            )}
            <WarningVoucherFooter
              isShowWarningVoucher={isShowWarningVoucher}
              isShowWarningRedeem={isShowWarningRedeem}
              dataVoucherWarning={dataVoucherWarning}
              handleUpdateVoucherList={handleUpdateVoucherList}
              setDataVoucherWarning={setDataVoucherWarning}
              setIsShowWarningVoucher={setIsShowWarningVoucher}
              handleVerifyRedeemVoucherGLobal={handleVerifyRedeemVoucherGLobal}
            />
            <SummaryFooter
              cart={cart}
              isShowBottomSheet={isShowBottomSheet}
              isShowWarningVoucher={isShowWarningVoucher}
              isShowWarningRedeem={isShowWarningRedeem}
              isLoading={isLoading}
              isLoadingDeliveryList={isLoadingDeliveryList}
              isLoadingVoucherList={isLoadingVoucherList || isLoadingVoucherLoyalty}
              isLoadingPaymentMethodList={isLoadingPaymentMethodList}
              paymentSummary={paymentSummary}
              handleSubmit={handleSubmit}
            />
          </div>

          {showClosed && (
            <OutletClosedCard open={showClosed} onBackHome={() => navigate.push(`${UFOODX_BASE_URL}`)} />
          )}
        </div>
      </div>
    </>
  );
};

export default Summary;
